/*
 * Copyright (c) 2023 CalAmp Corp. All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconSize} from '../types/types';

interface EventHistoryTimeIconProps {
  size?: IconSize | number;
  color?: string;
}

/*
 * Defines the Design Language System (DLS) Event History Time Icon component for the
 * Event Popup.
 */
export const EventHistoryTimeIcon = ({size = 14, color = dlsColor('grey3')}: EventHistoryTimeIconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 14 14" fill="none">
      <path d="M6.71436 4.00006V7.65149L8.54864 8.99435" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round"/>
      <circle cx="7" cy="7" r="6" stroke={color} strokeWidth="1.5"/>
    </svg>
  );
};
